export default __webpack_public_path__ + "static/media/location.47cb5cc5.svg";